var map = {
	"./blidinje.jpg": "974a",
	"./delta.jpg": "4681",
	"./dubrovnik.jpg": "ab79",
	"./hutovo.jpg": "02a9",
	"./korcula.jpg": "b7a5",
	"./kravice.jpg": "62b5",
	"./medugorje.jpg": "297c1",
	"./mljet.jpg": "4c6a",
	"./mogorjelo.jpg": "60eb",
	"./mostar.jpg": "b5f1",
	"./narona.jpg": "2d6f",
	"./pocitelj.jpg": "3ee3",
	"./ston.jpg": "2cc6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1961";